import { HDateHour } from '@shared/src/datatypes/HDateHour';
import { Languages } from '@shared/src/enums/Languages';
import { NoticeQuestionTypes } from '@shared/src/enums/NoticeQuestionTypes';

export class NoticeViewQuestionDto {
    public noticeQuestionId: number;
    public noticeQuestionKey: string;
    public questionType: NoticeQuestionTypes;
    public isRequired: boolean;
    public questionText: string;
    public yesLabel: string;
    public noLabel: string;
    public answer: boolean;
}

export class NoticeViewDto {
    public noticeId: number;
    public noticeKey: string;
    public language: Languages;
    public title: string;
    public bodyHtml: string;
    public readAt: HDateHour;
    public questions: NoticeViewQuestionDto[];
}

export class NoticeAnswerDto {
    public noticeQuestionId: number;
    public answer: boolean;
}

export class NoticeAcknowledgeDto {
    public answers: NoticeAnswerDto[] = [];
}
